import type { TenantRole } from "@hyphesync/shared";

/** Display names for the stored roles (shared by every page that shows one). */
export const ROLE_LABEL: Record<TenantRole, string> = { admin: "Admin", manager: "Manager", viewer: "Viewer" };
export const roleLabel = (r: TenantRole): string => ROLE_LABEL[r];
